import React, { Component } from 'react';
import './ReferralsList.css'
class ReferralsList extends Component {

    openDetails =() => {
        var get_className_of_body =  document.getElementById(this.props.detailsBodyId);
        if(get_className_of_body.className === "hide")
            {
                get_className_of_body.className = "show";
            }
        else 
            {
                get_className_of_body.className = "hide";
            }
            
    }
    render() { 
        return ( 
    

           <tr className="referrals">
               <td>
                    <h3 className="referralName"> <i className="fas fa-user"></i> <span> </span>{this.props.referralName}</h3>
               </td>
               <td>
                    <span className="referral-details-span">{this.props.referralPayout}</span>
               </td>
               <td>
                    <span className="referral-details-span">{this.props.referralAddress}</span>
               </td>
               <td>
                    <span className="referral-details-span">{this.props.referralEmail}</span>
               </td>
               <td>
                    <span id="jobStatusSpan" className={this.props.referralStatus === "Completed" ? "greenStatus" : "orangeStatus"}> {this.props.referralStatus}</span>
               </td>
           </tr>
        )
    }
}

export default ReferralsList;




// WEBPACK FOOTER //
// ./src/Components/Pages/MyHaven/HavenReferrals/ReferralsPage/ReferralsList.jsx